import React from "react";
import NewsFirstCol from "../../home/components/NewsFirstCol";
import NewsSecondCol from "../../home/components/NewsSecondCol";

const SidebarNews = () => {
  return (
    <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
      <NewsFirstCol />
      <div className="w-100"></div>
      <NewsSecondCol />
    </div>
  );
};

export default SidebarNews;
